
  var _styles = {
  "unjoined-banner-v2": {
    "position": "relative",
    "width": "9.57333rem",
    "height": "4.64rem",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "unjoined-banner-v2__bg": {
    "position": "absolute",
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.52rem",
    "height": "4.58667rem",
    "borderRadius": "0.32rem",
    "zIndex": 0
  },
  "unjoined-banner-v2__content": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "9.57333rem",
    "height": "4.64rem",
    "zIndex": 2
  },
  "unjoined-banner-v2__header": {
    "position": "absolute",
    "top": "0.32rem",
    "left": "0.32rem",
    "width": "8.90667rem",
    "height": "0.48rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "unjoined-banner-v2__title": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.4rem",
    "fontWeight": "600",
    "color": "rgb(0,28,55)"
  },
  "unjoined-banner-v2__rule": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "unjoined-banner-v2__rule-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "color": "rgb(85,85,85)",
    "marginRight": "0.05333rem"
  },
  "unjoined-banner-v2__rule-arrow": {
    "width": "0.29333rem",
    "height": "0.29333rem"
  },
  "unjoined-banner-v2__panel": {
    "position": "absolute",
    "top": "1.06667rem",
    "left": "0.32rem",
    "width": "8.93333rem",
    "height": "2.02667rem",
    "borderRadius": "0.21333rem",
    "backgroundColor": "rgb(255,243,245)"
  },
  "unjoined-banner-v2__hand": {
    "position": "absolute",
    "top": "0.22667rem",
    "left": "0.29333rem",
    "width": "1.38667rem",
    "height": "1.38667rem",
    "zIndex": 1
  },
  "unjoined-banner-v2__text-col": {
    "position": "relative",
    "zIndex": 0,
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "paddingTop": "0.41333rem",
    "paddingLeft": "2.02667rem"
  },
  "unjoined-banner-v2__reward-row": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "marginBottom": "0.10667rem"
  },
  "unjoined-banner-v2__amount": {
    "fontFamily": "MTfin-bold2.0",
    "fontSize": "0.42667rem",
    "fontWeight": "500",
    "color": "rgb(255,45,25)"
  },
  "unjoined-banner-v2__amount-unit": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "fontWeight": "500",
    "color": "rgb(255,45,25)",
    "marginRight": "0.05333rem"
  },
  "unjoined-banner-v2__reward-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "fontWeight": "400",
    "color": "rgb(17,17,17)"
  },
  "unjoined-banner-v2__sub": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "fontWeight": "400",
    "color": "rgb(85,85,85)"
  },
  "unjoined-banner-v2__cta": {
    "position": "absolute",
    "top": "3.36rem",
    "left": "2.02667rem",
    "width": "5.52rem",
    "height": "1.06667rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "13.32rem",
    "overflow": "hidden"
  },
  "unjoined-banner-v2__cta-bg": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "right": 0,
    "bottom": 0,
    "zIndex": 0
  },
  "unjoined-banner-v2__cta-text": {
    "position": "relative",
    "zIndex": 1,
    "fontFamily": "PingFang SC",
    "fontSize": "0.4rem",
    "fontWeight": "500",
    "color": "rgb(255,255,255)"
  }
};



  module.exports = _styles;
  